import { ReactElement } from "react";
import React, { Suspense } from 'react';
import { Box, Typography } from "@mui/material";

export function SuspenseWrapper({
    component
}: {
    component: ReactElement
}) {
    return (
        <Suspense
            fallback={
                <Box
                    sx={{
                        height: '100dvh',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h6" color="text.secondary">
                        Loading…
                    </Typography>
                </Box>
            }
        >
            {component}
        </Suspense>
    );
}